import { useI18n } from './I18nProvider';

export default function LanguageSwitcher({ compact = false }) {
  const { locale, locales, setLocale, t } = useI18n();
  return <label className={`language-switcher ${compact ? 'language-switcher-compact' : ''}`}>
    <span className="sr-only">{t('language.label')}</span>
    <select value={locale} onChange={(event) => setLocale(event.target.value)} aria-label={t('language.label')}>
      {locales.map((code) => <option key={code} value={code}>{compact ? code.toUpperCase() : t(`language.${code}`)}</option>)}
    </select>
  </label>;
}
